import React from "react";

import HomeRouter from "../views/private/home";
import {AuthProvider} from "../contexts/AuthContext";

export default function ValidateSession() {

  return (
        <AuthProvider>
          <HomeRouter />
        </AuthProvider>
  );
}
